module.exports = __webpack_public_path__ + "img/智能变配电单位概况.e0351864.png";